import { __assign } from "tslib";
import biLogger from '@wix/web-bi-logger';
import ddt from '@wix/da-ddt';
import { getReferrer, commitReferrer } from '../redux/routing/referrer';
import { BiEventType } from './constants';
import { validateEvent } from './eventValidator';
var BiLogger = /** @class */ (function () {
    function BiLogger() {
        this.defaultOptions = {
            version: 'eclipse;major',
            platform: 'desktop',
        };
    }
    BiLogger.prototype.getLogger = function (contextData) {
        if (typeof window !== 'undefined') {
            this.defaultOptions.url = window.location.toString();
            if (document.referrer) {
                this.defaultOptions.referer = document.referrer;
            }
        }
        if (contextData) {
            this.defaultOptions.platform = contextData.isMobile
                ? 'mobile'
                : 'desktop';
            if (contextData.biClientId) {
                this.defaultOptions.client_id = contextData.biClientId;
            }
            if (contextData.useridUuid) {
                this.defaultOptions.uuid = contextData.useridUuid;
            }
            this.defaultOptions.requestid = contextData.requestId;
            this.defaultOptions.view = contextData.view;
            this.defaultOptions.component = contextData.component;
        }
        return biLogger
            .factory({ endpoint: 'da-client', trackSession: false })
            .updateDefaults(this.defaultOptions)
            .logger();
    };
    BiLogger.prototype.log = function (contextData, eventData) {
        // we are not supposed to send client events from server
        if (typeof window === 'undefined') {
            ddt.error('bilogger', 'Attempted to send client event in SSR, fix me now', eventData);
            return Promise.resolve();
        }
        // if a new pageview, time to save referrer
        if (eventData.evid === BiEventType.PAGEVIEW) {
            commitReferrer();
        }
        var myLogger = this.getLogger(contextData);
        var logData = validateEvent(__assign(__assign(__assign({}, this.defaultOptions), { referer: getReferrer() }), eventData));
        // you may need to instruct your browser to preserve logs to be able to
        // see these messages
        ddt.log('bilogger', "(evid: " + logData.evid + ")", JSON.stringify(logData));
        // we are not supposed to send events from dev
        if (process.env.NODE_ENV !== 'production') {
            return Promise.resolve();
        }
        return myLogger.log(logData);
    };
    return BiLogger;
}());
export { BiLogger };
export var logger = new BiLogger();
//# sourceMappingURL=BiLogger.logger.js.map